import { CSSProperties, ReactNode } from 'react';

const row: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  flexWrap: 'wrap',
  minHeight: 40,
  padding: '2px 2px 0',
};

const causeStyle: CSSProperties = {
  fontSize: 12.5,
  color: 'var(--bui-fg-secondary)',
};

const rightStyle: CSSProperties = {
  marginLeft: 'auto',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
};

export const SummaryLine = ({
  pill,
  cause,
  meta,
  right,
}: {
  pill: ReactNode;
  cause?: string;
  meta?: ReactNode;
  right?: ReactNode;
}) => (
  <div style={row}>
    {pill}
    {cause && <span style={causeStyle}>{cause}</span>}
    {meta}
    {right && <span style={rightStyle}>{right}</span>}
  </div>
);
